// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pro-rata-report-generator {
  margin-top: 15px;
}

.report-button {
  background-color: #f2e9ff;
  border: 1px solid #d9b8ff;
  color: #6200cc;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.9rem;
}

.report-button:hover {
  background-color: #e7ccff;
  border-color: #cc8bff;
}

.report-modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.report-modal-header {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.report-modal-header h2 {
  margin: 0;
  font-size: 1.4rem;
  color: #6200cc;
}

.report-selection-container {
  padding: 20px;
  overflow-y: auto;
}

.report-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.report-type-card {
  background-color: #fff;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.report-type-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  border-color: #d9b8ff;
}

.report-type-card h3 {
  margin: 0;
  color: #333;
  font-size: 1.2rem;
  text-align: center;
}

.report-type-card p {
  margin: 0;
  color: #555;
  font-size: 0.9rem;
  text-align: center;
}

.report-icon {
  font-size: 2.5rem;
  color: #6200cc;
  margin-bottom: 10px;
}

.report-date-filter-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.back-button-container {
  margin-bottom: 10px;
}

.back-to-reports-button {
  background: none;
  border: none;
  color: #6200cc;
  cursor: pointer;
  padding: 0;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
}

.back-to-reports-button:hover {
  text-decoration: underline;
}

.report-info {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #6200cc;
}

.report-info .report-icon {
  font-size: 2rem;
  margin-bottom: 0;
}

.report-info-text h3 {
  margin: 0 0 5px 0;
  color: #333;
}

.report-info-text p {
  margin: 0;
  color: #555;
  font-size: 0.9rem;
}

.date-inputs-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.date-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-input-group label {
  font-weight: 500;
  color: #333;
}

.date-input-wrapper {
  position: relative;
  cursor: pointer;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #fff;
  transition: all 0.2s ease;
}

.date-input-wrapper:hover {
  border-color: #6200cc;
  background-color: #faf5ff;
}

.date-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  z-index: 1;
}

.date-input {
  width: 100%;
  padding: 10px 10px 10px 35px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  background: transparent;
  cursor: pointer;
}

.date-input:focus {
  outline: none;
}

.report-error-message {
  padding: 10px;
  background-color: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  margin-top: 10px;
}

.report-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.secondary-button,
.primary-button {
  padding: 10px 15px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.secondary-button {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #ced4da;
}

.secondary-button:hover:not(:disabled) {
  background-color: #e9ecef;
}

.primary-button {
  background-color: #6200cc;
  color: white;
  border: none;
}

.primary-button:hover:not(:disabled) {
  background-color: #5100a9;
}

.secondary-button:disabled,
.primary-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .report-modal-content {
    width: 95%;
    max-width: 95%;
  }
  
  .report-types-grid {
    grid-template-columns: 1fr;
  }
  
  .date-inputs-container {
    grid-template-columns: 1fr;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/ProRataReportGenerator.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".pro-rata-report-generator {\n  margin-top: 15px;\n}\n\n.report-button {\n  background-color: #f2e9ff;\n  border: 1px solid #d9b8ff;\n  color: #6200cc;\n  border-radius: 4px;\n  padding: 0.5rem 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 0.9rem;\n}\n\n.report-button:hover {\n  background-color: #e7ccff;\n  border-color: #cc8bff;\n}\n\n.report-modal-content {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 700px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.report-modal-header {\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n}\n\n.report-modal-header h2 {\n  margin: 0;\n  font-size: 1.4rem;\n  color: #6200cc;\n}\n\n.report-selection-container {\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.report-types-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.report-type-card {\n  background-color: #fff;\n  border: 1px solid #e8eaed;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.report-type-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);\n  border-color: #d9b8ff;\n}\n\n.report-type-card h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2rem;\n  text-align: center;\n}\n\n.report-type-card p {\n  margin: 0;\n  color: #555;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.report-icon {\n  font-size: 2.5rem;\n  color: #6200cc;\n  margin-bottom: 10px;\n}\n\n.report-date-filter-container {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.back-button-container {\n  margin-bottom: 10px;\n}\n\n.back-to-reports-button {\n  background: none;\n  border: none;\n  color: #6200cc;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.back-to-reports-button:hover {\n  text-decoration: underline;\n}\n\n.report-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n  border-left: 4px solid #6200cc;\n}\n\n.report-info .report-icon {\n  font-size: 2rem;\n  margin-bottom: 0;\n}\n\n.report-info-text h3 {\n  margin: 0 0 5px 0;\n  color: #333;\n}\n\n.report-info-text p {\n  margin: 0;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.date-inputs-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.date-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.date-input-group label {\n  font-weight: 500;\n  color: #333;\n}\n\n.date-input-wrapper {\n  position: relative;\n  cursor: pointer;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  background-color: #fff;\n  transition: all 0.2s ease;\n}\n\n.date-input-wrapper:hover {\n  border-color: #6200cc;\n  background-color: #faf5ff;\n}\n\n.date-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n  z-index: 1;\n}\n\n.date-input {\n  width: 100%;\n  padding: 10px 10px 10px 35px;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  background: transparent;\n  cursor: pointer;\n}\n\n.date-input:focus {\n  outline: none;\n}\n\n.report-error-message {\n  padding: 10px;\n  background-color: #f8d7da;\n  color: #721c24;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.report-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.secondary-button,\n.primary-button {\n  padding: 10px 15px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.secondary-button {\n  background-color: #f8f9fa;\n  color: #6c757d;\n  border: 1px solid #ced4da;\n}\n\n.secondary-button:hover:not(:disabled) {\n  background-color: #e9ecef;\n}\n\n.primary-button {\n  background-color: #6200cc;\n  color: white;\n  border: none;\n}\n\n.primary-button:hover:not(:disabled) {\n  background-color: #5100a9;\n}\n\n.secondary-button:disabled,\n.primary-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.fa-spin {\n  animation: fa-spin 2s infinite linear;\n}\n\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .report-modal-content {\n    width: 95%;\n    max-width: 95%;\n  }\n  \n  .report-types-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .date-inputs-container {\n    grid-template-columns: 1fr;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
